module.exports = __webpack_public_path__ + "static/image18@2x-6973cbdbf33f58bf56a5b2f844b58c57.png";